(() => {
  (() => {
    class t extends HTMLElement {
      currentVariant;
      form;
      swatch;
      input;
      prices;
      priceDiscount;
      specialDiscount;
      option0;
      option1;
      option2;
      option3;
      imageBar;
      stars;
      button;
      SignButton;
      save_additional;
      affirmText;
      gallery;
      gallery2;
      nGallery;
      nVideo;
      image;
      select;
      noSelect;
      options;
      wrapper;
      afterPayPrice;
      additionalText;
      shopBarToggles;
      quantitySelector;
      constructor() {
        super(),
          (this.currentVariant = window.theme.product.currentVariant),
          (this.form = this.querySelector("form")),
          (this.swatch = this.querySelector("#variantPicker")),
          (this.save_additional = this.querySelector(
            ".discount-additional-text"
          )),
          (this.input = this.form.querySelector('input[name="id"]')),
          (this.prices = this.querySelectorAll(".product-price")),
          (this.priceDiscount = this.querySelectorAll(
            ".product-price-discount"
          )),
          (this.specialDiscount = this.querySelectorAll(
            ".special-discount-item"
          )),
          (this.imageBar = document.querySelector(".shop-bar_image")),
          (this.shopBarToggleContainer = document.querySelector(".shop-bar-toggle-container")),
          (this.productFormContainer = document.querySelector(".product__info-container")),
          (this.shopBarClose = document.querySelector(".shop-bar-close")),
          (this.stars = this.querySelector("[data-oke-star-rating]")),
          (this.button = this.querySelector(".product-form__submit")),
          (this.SignButton = this.querySelector(".signup-btn")),
          (this.affirmText = this.querySelector(".affirm-as-low-as")),
          (this.gallery = document.querySelector(
            "product-form .product-gallery"
          )),
          (this.gallery2 = document.querySelector(
            ".product-gallery-grid .product-gallery"
          )),
          (this.nGallery = document.querySelector(".product-gallery-grid")),
          (this.nVideo = document.querySelector(
            ".product-gallery-grid .product-gallery_item-video"
          )),
          (this.wrapper = document.querySelector(".product__info-wrapper")),
          (this.shopBarToggleMobile = document.querySelector("#shop-bar-toggle-mobile")),
          (this.additionalText = document.querySelector(
            "#product-form_additional-text"
          )),
          (this.afterPayPrice = document.querySelector(".afterpay-price")),
          (this.productLabel = document.querySelector(
            "#best-seller-label-pdp"
          )),
          (this.submitting = !1),
          (this.shopBarToggles = this.querySelectorAll(".shop-bar-toggle")),
          (this.quantitySelector = this.querySelector(".quantity")),
          "Gift Card" === window.theme.product.type &&
            ((this.image = document.querySelector(
              "product-form .product-gallery img"
            )),
            (this.select = this.swatch.querySelector(
              ".blanket-options_select"
            )),
            (this.noSelect = !0),
            this.select.addEventListener(
              "click",
              this.handleSelect.bind(this)
            )),
          this.swatch &&
            ((this.option0 = this.swatch.querySelector(
              ".product_option0-value"
            )),
            (this.option1 = this.swatch.querySelector(
              ".product_option1-value"
            )),
            (this.option2 = this.swatch.querySelector(
              ".product_option2-value"
            )),
            (this.option3 = this.swatch.querySelector(
              ".product_option3-value"
            )),
            this.swatch.addEventListener(
              "change",
              this.onVariantChange.bind(this)
            ),
            (this.firstLoad = !0),
            this.applySecondSkinDefaultQueenSize(),
            this.onVariantChange(),
            this.showOnlyAvailableColors()),
          this.form.addEventListener("submit", this.handleForm.bind(this)),
          this.classList.contains("shop-bar-disabled") ||
            window.addEventListener("scroll", this.handleScroll.bind(this)),
          this.stars &&
            this.stars.addEventListener("click", () => {
              const t = document.querySelector(
                "[data-oke-carousel], [data-oke-widget]"
              );
              t &&
                window.scrollTo({ top: t.offsetTop - 70, behavior: "smooth" });
            }),
          this.handleLables(),
          this.shopBarClose.addEventListener("click", () => {
            this.productFormContainer.classList.remove("active");
          }),
            this.shopBarToggleMobile.addEventListener("click", () => {
              this.productFormContainer.classList.toggle("active");
            });
            this.initUpsell();
        }

        applySecondSkinDefaultQueenSize() {
          if (!document.body.classList.contains("second-skin-pdp")) return;
          if (new URLSearchParams(window.location.search).has("variant")) return;
          if (!this.swatch) return;

          const queenInput = this.swatch.querySelector(
            '#sheets-size-options input[value="Queen"], input[name="Bed Size"][value="Queen"], input[name="Size"][value="Queen"]'
          );
          if (!queenInput || queenInput.checked || queenInput.disabled) return;

          queenInput.checked = true;
        }

        initUpsell() {
          if (!window.theme || !window.theme.product || !window.theme.product.id) return;
          const productId = window.theme.product.id;
          
          const findContainer = () => {
             const container = this.querySelector('.product-upsell-wrapper');
             if (container) return container;
             return null;
          };

          const container = findContainer();
          if (!container) {
             console.warn('Upsell container not found immediately.');
             return;
          }

          // Fetch data from our custom JSON section to get metafields
          fetch(window.Shopify.routes.root + `recommendations/products?section_id=upsell-json&product_id=${productId}&limit=3&intent=related`)
            .then(response => response.text())
            .then(text => {
              // Parse the HTML to find our JSON
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const jsonContainer = doc.querySelector('[data-upsell-json]');
              
              if (!jsonContainer) return;

              let data;
              try {
                data = JSON.parse(jsonContainer.innerText.trim());
              } catch (e) {
                console.error("Error parsing upsell JSON", e);
                return;
              }

              const products = data.products;

              if (products && products.length > 0) {
                let html = '<div class="upsell-header">Complete your sleep set:</div>';
                let hasAvailable = false;
                
                products.forEach(product => {
                  if (!product.available) return;
                  
                  // Filter out variants that are OOS or Hidden
                  const hiddens = product.hiddens || [];
                  let validVariants = product.variants.filter(v => {
                    // Check availability
                    if (!v.available) return false;
                    
                    // Check hidden metafields against option values
                    // Note: 'hiddens' usually contains the option value strings
                    if (hiddens.includes(v.option1)) return false;
                    if (v.option2 && hiddens.includes(v.option2)) return false;
                    if (v.option3 && hiddens.includes(v.option3)) return false;
                    
                    return true;
                  });

                  validVariants = this.filterUpsellVariants(product, validVariants);

                  if (validVariants.length === 0) return;
                  hasAvailable = true;

                  const mainSize = this.getMainProductBeddingSize();
                  const firstAvailableVariant =
                    (mainSize &&
                      validVariants.find((variant) =>
                        variant.options.some(
                          (option) =>
                            this.normalizeOptionValue(option) ===
                            this.normalizeOptionValue(mainSize)
                        )
                      )) ||
                    validVariants[0];
                  const image = product.featured_image || ''; 
                  const title = product.title;
                  
                  // Helper to format price
                  // const formatPrice = (cents) => '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
const formatPrice = (cents) => '$' + Math.round(cents / 100);
                  let priceDisplay = formatPrice(firstAvailableVariant.price);
                   let discountedPrice = formatPrice(firstAvailableVariant.original_price);
                  // Variant Options Logic
                  let optionsHtml = '';
                  
                  if (product.variants.length > 1 && product.options.length > 0) {
                    optionsHtml = `<div class="upsell-variant-options">`;
                    
                    product.options.forEach((option, index) => { // option is just string name in standard JSON, but in our custom JSON it might be object if we mapped it. Check upsell-json.liquid.
                      // In upsell-json.liquid: "options": {{ product.options | json }} -> ["Size", "Color"]
                      // Wait, product.options in Liquid outputs just names if used directly? No, it outputs strings array.
                      // Adjusting JS to handle array of strings.
                      
                      const optionName = typeof option === 'string' ? option : option.name;
                      const isColor = optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour';
                      
                      const activeValue = firstAvailableVariant.options[index];

                      // Get unique valid values for this option from our VALID variants only
                      let validValues = [...new Set(validVariants.map(v => v.options[index]))];

                      if (
                        this.isSheetsProductPage() &&
                        this.isBeddingSizeOptionName(optionName)
                      ) {
                        validValues = validValues.filter(
                          (value) => !this.isHiddenBeddingSize(value)
                        );
                      }
                      
                      // If only 1 valid value exists for this option, and it's not the only option, maybe simple text? 
                      // User wants selectors. Let's keep selectors if > 1 valid value OR if it's a multi-variant product generally.
                      // But if validValues has only 1 item, a dropdown is redundant but consistent.
                      
                      if(validValues.length > 0) {
                          // Custom Select HTML
                          optionsHtml += `
                            <div class="upsell-custom-select" data-option-index="${index}" data-option-name="${optionName}">
                              <div class="upsell-custom-trigger" tabindex="0">
                                <span>
                                  ${activeValue}
                                  ${isColor ? `<span class="upsell-swatch color-${activeValue.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')}"></span>` : ''}
                                </span>
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" class="icon-chevron-down">
                                  <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                              <div class="upsell-custom-options">
                                ${validValues.map(value => {
                                  const isSelected = value === activeValue ? 'selected' : '';
                                  return `
                                    <div class="upsell-custom-option ${isSelected}" data-value="${value}">
                                      ${value}
                                      ${isColor ? `<span class="upsell-swatch color-${value.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')}"></span>` : ''}
                                    </div>
                                  `;
                                }).join('')}
                              </div>
                            </div>
                          `;
                      }
                    });
                    
                    optionsHtml += `</div>`;
                  }

                  // Embed valid variants data safely as JSON string in data attribute
                  const variantsJson = JSON.stringify(validVariants).replace(/"/g, '&quot;');
             let priceHtml = '';
        if (
          discountedPrice &&
          discountedPrice > priceDisplay
        ) {
          priceHtml = `
            <div class="upsell-price"><span>${priceDisplay}</span></div>
            <div class="compare_at-price">${discountedPrice}</div>
          `;
        } else {
          
          priceHtml = `
            <div class="upsell-price">${priceDisplay}</div> <div class="compare_at-price"></div>
          `;
        }
                  const normalizedTitle = title?.toString().trim().toLowerCase() || '';
                  const displayTitle = normalizedTitle.includes('tree napper') ? 'TENCEL™ Weighted Blanket' : title;
                  html += `
                    <div class="upsell-card" data-variant-id="${firstAvailableVariant.id}" data-variants="${variantsJson}">
                      <div class="upsell-top-row">
                        <img src="${image}" alt="${title}" class="upsell-image">
                        <div class="upsell-info-main">
                          <h4>${displayTitle}</h4>
                          <div class="price-div">
                          ${priceHtml}
                          </div>
                        </div>
                        <div class="upsell-action">
                          <button type="button" class="btn btn--upsell add-to-cart-btn upsell-add-btn" data-variant-id="${firstAvailableVariant.id}" aria-label="Add ${title} to cart">Add</button>
                        </div>
                      </div>
                      ${optionsHtml ? `<div class="upsell-bottom-row">${optionsHtml}</div>` : ''}
                    </div>
                  `;
                });

                if (hasAvailable) {
                  container.innerHTML = html;
                  container.removeAttribute('hidden');
                  this.initUpsellEvents(container);
                }
              }
            })
            .catch(e => console.error("Error fetching upsells:", e));
        }

        initUpsellEvents(container) {
          // Toggle Dropdowns
          container.querySelectorAll('.upsell-custom-trigger').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
              e.stopPropagation(); // Stop bubbling
              const currentSelect = trigger.closest('.upsell-custom-select');
              
              // Close other open dropdowns in the same container
              container.querySelectorAll('.upsell-custom-options.open').forEach(opt => {
                if (opt.parentElement !== currentSelect) opt.classList.remove('open');
              });

              const optionsEl = currentSelect.querySelector('.upsell-custom-options');
              optionsEl.classList.toggle('open');
            });
          });

          // Close on outside click
          document.addEventListener('click', (e) => {
             if (!e.target.closest('.upsell-custom-select')) {
                container.querySelectorAll('.upsell-custom-options.open').forEach(opt => opt.classList.remove('open'));
             }
          });

          // Handle Option Selection
          container.querySelectorAll('.upsell-custom-option').forEach(optionEl => {
             optionEl.addEventListener('click', (e) => {
                e.stopPropagation();
                const selectEl = optionEl.closest('.upsell-custom-select');
                const card = selectEl.closest('.upsell-card');
                const triggerSpan = selectEl.querySelector('.upsell-custom-trigger span');
                const optionsList = selectEl.querySelector('.upsell-custom-options');
                
                // Update Selected Value UI
                const newValue = optionEl.dataset.value;
                const isColor = selectEl.dataset.optionName.toLowerCase() === 'color';
                
                // Update trigger text/swatch
                triggerSpan.innerHTML = `
                  ${newValue}
                  ${isColor ? `<span class="upsell-swatch color-${newValue.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')}"></span>` : ''}
                `;
                
                // Update selected class in list
                selectEl.querySelectorAll('.upsell-custom-option').forEach(opt => opt.classList.remove('selected'));
                optionEl.classList.add('selected');
                
                // Close dropdown
                optionsList.classList.remove('open');

                // Logic to update Card State (Price, Image, Variant ID) based on ALL selections
                this.updateUpsellCard(card);
             });
          });

          container.querySelectorAll(".upsell-add-btn").forEach((button) => {
            button.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              const card = button.closest(".upsell-card");
              this.addUpsellToCart(card, button);
            });
          });
        }

        async addUpsellToCart(card, button) {
          const variantId = card?.dataset?.variantId;
          if (!variantId || button.disabled || button.classList.contains("loading")) {
            return;
          }

          const originalText = button.textContent;
          button.classList.add("loading");
          button.setAttribute("disabled", "true");
          button.textContent = "Adding...";

          try {
            const response = await fetch(
              window.Shopify.routes.root + "cart/add.js",
              {
                ...window.theme.fetchConfig(),
                body: JSON.stringify({
                  id: parseInt(variantId, 10),
                  quantity: 1,
                  sections: ["cart-drawer"],
                  sections_url: window.location.pathname,
                }),
              }
            );
            const data = await response.json();

            if (data.status) {
              throw data;
            }

            if (data?.sections) {
              window.theme.cart.render(data.sections["cart-drawer"]);
            } else {
              window.theme.cart.render(true);
            }

            button.textContent = "Added";
            setTimeout(() => {
              button.textContent = originalText;
            }, 2000);
          } catch (err) {
            console.error(err);
            button.textContent = originalText;
            if (err?.description) {
              alert(err.description);
            }
          } finally {
            button.classList.remove("loading");
            const variants = JSON.parse(card.dataset.variants || "[]");
            const variant = variants.find(
              (v) => String(v.id) === String(card.dataset.variantId)
            );
            if (variant?.available) {
              button.removeAttribute("disabled");
            }
          }
        }

        updateUpsellCard(card) {
          const formatPrice = (cents) => '$' + Math.round(cents / 100);
           const variants = JSON.parse(card.dataset.variants);
           const selectors = card.querySelectorAll('.upsell-custom-select');
           
           // Gather current selections
           // We assume the order of selectors matches option1, option2, etc.
           // data-option-index is 0-based.
           const currentOptions = {};
           selectors.forEach(sel => {
              const index = parseInt(sel.dataset.optionIndex);
              const val = sel.querySelector('.upsell-custom-option.selected').dataset.value;
              currentOptions[`option${index + 1}`] = val; // option1, option2...
           });
           
           // Find matching variant
           const match = variants.find(v => {
              // Check if all existing options match
              // variants have option1, option2, option3
              let isMatch = true;
              for (const [key, val] of Object.entries(currentOptions)) {
                 if (v[key] !== val) isMatch = false;
              }
              return isMatch;
           });

           const priceEl = card.querySelector('.upsell-price');
           const imgEl = card.querySelector('.upsell-image');
           const addButton = card.querySelector('.upsell-add-btn');
             const compareEl = card.querySelector('.compare_at-price');
           if (match) {
             // Update UI
               if (match.original_price && match.original_price > match.price) {
             priceEl.innerHTML  = '<span>' + formatPrice(match.price) + '</span>';
               } else {
             priceEl.textContent =  formatPrice(match.price);


               }
               // ── UPDATE COMPARE PRICE ──
     if (compareEl) {
       if (match.original_price && match.original_price > match.price) {
         compareEl.textContent = formatPrice(match.original_price);
         compareEl.style.display = '';
       } else {
         compareEl.style.display = 'none'; // hide if no discount
       }
     }
             if (match.featured_image && match.featured_image.src) {
                imgEl.src = match.featured_image.src;
             }
             if (addButton) {
               addButton.dataset.variantId = match.id;
             }
             
             // If unavailable
             if (!match.available) {
                // Could disable or show text. For now let's just opacity
                priceEl.innerHTML += ' <span style="font-size:0.8em; color:red;">(Sold Out)</span>';
                if (addButton) addButton.disabled = true;
             } else {
                if (addButton) addButton.disabled = false;
             }
             
             card.dataset.variantId = match.id;
           } else {
             // Variant doesn't exist (e.g. combination invalid)
             priceEl.textContent = 'Unavailable';
             if (compareEl) compareEl.style.display = 'none';
             if (addButton) addButton.disabled = true;
             card.removeAttribute('data-variant-id');
           }
        }
      showOnlyAvailableColors() {
        const colorInputs = this.swatch?.querySelectorAll('input[name="Color"]');
        if (!window.theme.hideUnavailableWeights || !colorInputs?.length) return;
        if (window.theme.product.landing) return;

        const options = window.theme.product.options || [];
        const colorIndex = options.findIndex((name) => {
          const normalized = String(name).toLowerCase();
          return normalized === "color" || normalized === "colour";
        });
        // Color landing pages use Type/Color on the dummy product, but
        // variants come from the real napper where color is option1.
        const idx = window.theme.product.landing
          ? 0
          : colorIndex >= 0
            ? colorIndex
            : 0;

        colorInputs.forEach((input) => {
          const label =
            input.nextElementSibling ||
            this.swatch.querySelector(`label[for="${input.id}"]`);
          if (!label) return;

          const available = window.theme.product.variants.find(
            (variant) =>
              variant.options[idx] === input.value && variant.available
          );

          if (available) {
            label.removeAttribute("hidden");
          } else {
            label.setAttribute("hidden", "");
          }
        });
      }
      handleLables() {
        if ("Gift Card" !== window.theme.product.type && this.productLabel) {
          if (this.currentVariant.available) {
            this.productLabel.innerHTML = this.currentVariant.variant_label || "";
          } else {
            // If tag exists, keep showing it even if not available
            if (this.currentVariant.variant_label) {
              this.productLabel.innerHTML = this.currentVariant.variant_label;
            } 
          }
          this.productLabel.style.background =
            this.currentVariant.variant_label_color || "";
        }
      }
      handleScroll() {
        const toggleContainer = this.shopBarToggleContainer;
        const t = this.parentElement,
          i = this.formVisible();
        
        if (i) {
          // Form is visible - hide toggle container
          if (t.style.minHeight !== "") {
            t.style.minHeight = "";
          }
          toggleContainer.style.display = "none";
          this.classList.remove("shop-bar");
        } else {
          // Form is not visible - show toggle container
          if (t.style.minHeight === "") {
            t.style.minHeight = t.offsetHeight + "px";
          }
          toggleContainer.style.display = "flex";
          this.classList.add("shop-bar");
        }
      }
      formVisible() {
        let t = this.wrapper.offsetTop - 70,
          e = this.wrapper.offsetLeft,
          i = this.wrapper.offsetWidth,
          r = this.wrapper.offsetHeight;
        return (
          t < window.pageYOffset + window.innerHeight &&
          e < window.pageXOffset + window.innerWidth &&
          t + r > window.pageYOffset &&
          e + i > window.pageXOffset
        );
      }
      handleForm(t) {
        if ((t.preventDefault(), this.submitting)) return;

        if (this.isWeightLandingPage()) {
          this.updateWeightLandingColorVisibility();
          if (this.syncWeightLandingSelection()) {
            this.updateOptions();
          }
          this.updateWeightLandingVariant();
          this.updateVariantInput();
        }

        this.submitting = !0;
        const e = this.querySelector('[type="submit"]');
        e && (e.setAttribute("disabled", "true"), e.classList.add("loading"));

        // Check if button has link-to-checkout class
        const shouldRedirectToCheckout = e && e.classList.contains("link-to-checkout");

        if (window.theme.product.template == "biscuit-bundle") {
          const formData = window.theme.utils.serializeForm(this.form);
          const i = JSON.stringify([formData]);
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => t.json())
            .then((t) => {
              if (shouldRedirectToCheckout) {
                window.location.href = "/checkout";
              } else {
                window.theme.cart.render(t, !0); // Pass the response to the render function
              }
            })
            .catch((e) => {
              // Removed console.error
              t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              if (!shouldRedirectToCheckout) {
                const t = document.querySelector(".close");
                t && t.click();
              }
            });
        } else {
              // Standard single item add
              const i = JSON.stringify({
                ...JSON.parse(window.theme.utils.serializeForm(this.form)),
              });
              fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
                .then((t) => t.json())
                .then((t) => {
                  if (shouldRedirectToCheckout) {
                    window.location.href = "/checkout";
                  } else {
                    window.theme.cart.render(!0);
                  }
                })
                .catch((e) => {
                  // Removed console.error
                  t.target.submit();
                })
                .finally(() => {
                  (this.submitting = !1),
                    e &&
                      (e.classList.remove("loading"),
                      e.removeAttribute("disabled"));
                  if (!shouldRedirectToCheckout) {
                    const t = document.querySelector(".close");
                    t && t.click();
                  }
                });
        }
      }
      onVariantChange() {
        // Prevent nested re-entry from programmatic option sync (INP)
        if (this._variantUpdating) return;
        this._variantUpdating = true;

        try {
          if (this.isWeightLandingPage()) {
            this.updateWeightLandingColorVisibility();
            this.syncWeightLandingSelection();
          }
          this.updateOptions();
          this.updateMasterId();
          this.updateBeddingBundleSizes();
          this.checkAvailability();
          this.updateVariantInput();
          window.theme.product.currentVariant = this.currentVariant;

          this.currentVariant.options.forEach((t, e) => {
            this.setAttribute(`data-option${e + 1}`, t);
          });

          40597836693690 === this.currentVariant.id
            ? this.button.classList.add("hidden")
            : this.button.classList.remove("hidden");

          if ("product" in this.currentVariant) {
            window.theme.product.title = this.currentVariant.product;
          }

          if (this.noSelect && !this.select.hasAttribute("open")) {
            this.select.setAttribute("selected", "");
            this.noSelect = false;
          }

          // Felt feedback in the interaction path (price / labels)
          this.changeElements();
          this.handleLables();
          this.updateAfterpay();

          // Gallery rebuild is the main INP cost — run after paint (macrotask)
          const variantId = this.currentVariant.id;
          clearTimeout(this._mediaDeferTimer);
          this._mediaDeferTimer = setTimeout(() => {
            if (this.currentVariant?.id !== variantId) return;
            this.updateMedia();
            this.updateURL();
          }, 0);

          // Low priority third-party / visibility sync
          clearTimeout(this._lowPriorityTimer);
          this._lowPriorityTimer = setTimeout(() => {
            this.handleLpColors();
            this.updateAffirm();
            this.showOnlyAvailableColors();
            if (this.isBeddingBundleProduct()) this.checkAvailability();
          }, 0);
        } finally {
          this._variantUpdating = false;
        }
      }
      updateAfterpay() {
        if (this.afterPayPrice) {
          const t = this.currentVariant.price;
          this.afterPayPrice.dataset.mobilePrice = t;
        }
      }
      updateAffirm() {
        if (
          this.affirmText &&
          "undefined" != typeof affirm &&
          affirm.jsReady()
        ) {
          const t = this.currentVariant.price.replace("$", "") + "00";
          this.affirmText.setAttribute("data-amount", t), affirm.ui.refresh();
        }
      }
      updateOptions() {
        // Build options array based on product.options order, not DOM order
        // This ensures this.options[i] matches variant.options[i]
        if (window.theme.product.options) {
          this.options = window.theme.product.options.map((optionName) => {
            const input = this.swatch.querySelector(`input[name="${optionName}"]:checked`);
            return input ? input.value : false;
          });
        } else {
          // Fallback to old method if options not available
          const t = Array.from(this.swatch.querySelectorAll("fieldset"));
          this.options = t.map((t) => {
            const e = Array.from(t.querySelectorAll("input")).find(
              (t) => t.checked
            );
            return !!e && e.value;
          });
        }
        
        if (window.theme.product.landing) {
          this.options.shift();
          if (!this.options[1]) {
            const weightInput = this.swatch?.querySelector(
              'input[name="Weight (lbs)"]:checked'
            );
            if (weightInput?.value) this.options[1] = weightInput.value;
          }
        }

        if (this.isWeightLandingPage()) {
          const weightOptionName = window.theme.product.options?.find((name) =>
            String(name).includes("Weight")
          );
          if (weightOptionName) {
            const weightIndex =
              window.theme.product.options.indexOf(weightOptionName) - 1;
            if (weightIndex >= 0 && !this.options[weightIndex]) {
              const weightInput = this.swatch.querySelector(
                `input[name="${weightOptionName}"]:checked`
              );
              this.options[weightIndex] =
                weightInput?.value || this.currentVariant?.options?.[1] || false;
            }
          }
        }
      }
      updateWeightLandingLabels() {
        if (!this.isWeightLandingPage() || !this.swatch) return;

        const colorInput = this.swatch.querySelector('[name="Color"]:checked');
        const colorName =
          colorInput?.value || this.currentVariant?.options?.[0] || "";

        const colorLabel = this.swatch.querySelector(
          ".swatch-color .product_option1-value"
        );
        if (colorLabel && colorName) {
          colorLabel.textContent = colorName;
        }
        if (this.option1 && colorName) {
          this.option1.textContent = colorName;
        }

        if (this.option0 && this.currentVariant?.product) {
          this.option0.textContent = this.currentVariant.product;
          const typeHandle = this.querySelector('[name="Type"]:checked')?.value;
          this.option0.href =
            window.theme.product.urls?.[this.currentVariant.product] ||
            (typeHandle ? `/products/${typeHandle}` : this.option0.href);
        }

        if (this.option2 && this.currentVariant?.options?.[1]) {
          const weight = this.currentVariant.options[1]
            .replace("Queen ", "")
            .replace("King ", "");
          const dimension =
            window.theme.getDimension?.(this.currentVariant.options[1]) || "";
          this.option2.innerHTML = `${weight} lbs ${dimension}`.trim();
        }
      }
      isCuddlerCoverProduct() {
        return window.theme.product?.handle === "body-pillow-cover";
      }
      isBodyPillowProduct() {
        return window.theme.product?.handle === "body-pillow";
      }
      clearBodyPillowMaterialHidden() {
        if (!this.isBodyPillowProduct()) return;
        this.querySelectorAll(
          '[name="Cuddler Cover (Cover Materials)"]'
        ).forEach((input) => {
          const label =
            input.nextElementSibling ||
            document.querySelector(`label[for="${input.id}"]`);
          label?.removeAttribute("hidden");
        });
      }
      shouldHideCuddlerMedium() {
        return window.theme.hideCuddlerMedium === true;
      }
      isCuddlerMediumVariant(variant) {
        if (!variant?.options) return false;
        return variant.options.some((option) => {
          const value = String(option).toLowerCase();
          return value.includes("54") || value.includes("medium");
        });
      }
      ensureLargeCuddlerVariant() {
        if (!this.shouldHideCuddlerMedium()) return;

        const handle = window.theme.product?.handle;
        if (
          !["body-pillow", "cuddler-cover-test-bundle", "body-pillow-cover"].includes(
            handle
          )
        ) {
          return;
        }

        if (!this.isCuddlerMediumVariant(this.currentVariant)) return;

        const largeVariant = window.theme.product.variants.find(
          (variant) =>
            variant.available &&
            variant.options.some((option) => String(option).includes("75"))
        );

        if (!largeVariant) return;

        this.currentVariant = largeVariant;
        this.options = largeVariant.options.slice();
        largeVariant.options.forEach((option) => {
          this.querySelectorAll(`input[value="${option}"]`).forEach((input) => {
            input.checked = true;
          });
        });
      }
      isBeddingBundleProduct() {
        return window.theme.product?.handle === "bedding-bundle";
      }
      isSheetsProductPage() {
        if (this.isBeddingBundleProduct()) return false;

        const handle = window.theme.product?.handle;
        const template = window.theme.product?.template;
        const sheetHandles = ["bamboo-sheets", "duvet-covers"];
        const sheetTemplates = [
          "peppermint-sheet",
          "duvet-set",
          "bamboo-sheets",
          "bamboo-sheets-desktopmockup",
          "pillowcase",
          "fitted-sheet",
        ];

        return (
          sheetHandles.includes(handle) || sheetTemplates.includes(template)
        );
      }
      isBeddingSizeOptionName(optionName) {
        const normalized = String(optionName || "").toLowerCase();
        return normalized === "size" || normalized === "bed size";
      }
      getBeddingSizeOptionIndex(options = window.theme.product?.options || []) {
        return options.findIndex((name) =>
          this.isBeddingSizeOptionName(
            typeof name === "string" ? name : name?.name
          )
        );
      }
      getMainProductBeddingSize() {
        if (!this.isSheetsProductPage()) return null;

        const sizeIndex = this.getBeddingSizeOptionIndex();
        if (sizeIndex === -1) return null;

        const optionName = window.theme.product.options[sizeIndex];
        const optionNameStr =
          typeof optionName === "string" ? optionName : optionName?.name;

        return (
          this.currentVariant?.options?.[sizeIndex] ||
          this.options?.[sizeIndex] ||
          (optionNameStr
            ? this.querySelector(`input[name="${optionNameStr}"]:checked`)?.value
            : null) ||
          null
        );
      }
      filterUpsellVariants(product, variants) {
        if (!this.isSheetsProductPage()) return variants;

        const sizeIndex = this.getBeddingSizeOptionIndex(product.options || []);

        return variants.filter((variant) => {
          if (sizeIndex === -1) {
            return !variant.options.some(
              (option) => option && this.isHiddenBeddingSize(option)
            );
          }
          return !this.isHiddenBeddingSize(variant.options[sizeIndex]);
        });
      }
      isWeightLandingPage() {
        return (
          this.dataset.type === "weight-lp" &&
          this.dataset.weightLanding === "true"
        );
      }
      getWeightLandingTypeHandle() {
        return (
          this.querySelector('[name="Type"]:checked')?.value ||
          this.currentVariant?.handle ||
          window.theme.product?.handle ||
          null
        );
      }
      getWeightLandingWeight() {
        const weightInput = this.swatch?.querySelector(
          'input[name="Weight (lbs)"]:checked'
        );
        if (weightInput?.value) return weightInput.value;
        const weightOptionName = window.theme.product.options?.find((name) =>
          String(name).includes("Weight")
        );
        if (weightOptionName) {
          const namedInput = this.swatch?.querySelector(
            `input[name="${weightOptionName}"]:checked`
          );
          if (namedInput?.value) return namedInput.value;
        }
        return (
          this.options?.[1] ||
          this.currentVariant?.options?.[1] ||
          window.theme.product.currentVariant?.sizes?.[0] ||
          null
        );
      }
      getWeightLandingColorLabel(input) {
        if (!input?.id || !this.swatch) return null;
        return this.swatch.querySelector(`label[for="${input.id}"]`);
      }
      isWeightLandingColorValid(input, typeHandle) {
        if (!input || !typeHandle) return false;
        if (input.dataset.product && input.dataset.product !== typeHandle) {
          return false;
        }
        const label = this.getWeightLandingColorLabel(input);
        return (
          !!label &&
          !label.classList.contains("d-none") &&
          !label.hasAttribute("hidden")
        );
      }
      updateWeightLandingColorVisibility() {
        const typeHandle = this.getWeightLandingTypeHandle();
        if (!typeHandle || !this.swatch) return;

        this.swatch
          .querySelectorAll(".swatch-color label:not([hidden])")
          .forEach((label) => {
            if (label.dataset.product === typeHandle) {
              label.classList.remove("d-none");
            } else {
              label.classList.add("d-none");
            }
          });
      }
      syncWeightLandingSelection() {
        if (!this.isWeightLandingPage() || !this.swatch) return false;

        const typeHandle = this.getWeightLandingTypeHandle();
        if (!typeHandle) return false;

        const checked = this.swatch.querySelector('[name="Color"]:checked');
        if (this.isWeightLandingColorValid(checked, typeHandle)) return false;

        const nextInput = Array.from(
          this.swatch.querySelectorAll('[name="Color"]')
        ).find((input) => this.isWeightLandingColorValid(input, typeHandle));

        if (!nextInput || nextInput === checked) return false;

        nextInput.checked = true;
        return true;
      }
      updateWeightLandingVariant() {
        const typeHandle = this.getWeightLandingTypeHandle();
        if (!typeHandle) return false;

        const pool = window.theme.product.variants.filter(
          (variant) => variant.handle === typeHandle
        );
        if (!pool.length) return false;

        const colorInput = this.swatch?.querySelector('[name="Color"]:checked');
        const color =
          colorInput?.value ||
          this.options?.[0] ||
          this.currentVariant?.options?.[0] ||
          null;
        const weight = this.getWeightLandingWeight();

        let match = pool.find((variant) => {
          const colorMatch =
            !color ||
            this.normalizeOptionValue(variant.options[0]) ===
              this.normalizeOptionValue(color);
          const weightMatch =
            !weight ||
            this.normalizeOptionValue(variant.options[1]) ===
              this.normalizeOptionValue(weight);
          return colorMatch && weightMatch;
        });

        if (!match && color) {
          match = pool.find(
            (variant) =>
              variant.available &&
              this.normalizeOptionValue(variant.options[0]) ===
                this.normalizeOptionValue(color)
          );
        }

        if (!match && weight) {
          match = pool.find(
            (variant) =>
              variant.available &&
              this.normalizeOptionValue(variant.options[1]) ===
                this.normalizeOptionValue(weight)
          );
        }

        if (!match) {
          match = pool.find((variant) => variant.available) || pool[0];
        }

        if (match) this.currentVariant = match;
        return !!match;
      }
      shouldShowAllSizes() {
        return window.theme.product?.handle === "bamboo-sheets";
      }
      isHiddenBeddingSize(value) {
        const handles = ["bamboo-sheets", "duvet-covers", "bedding-bundle"];
        const templates = [
          "peppermint-sheet",
          "duvet-set",
          "bamboo-sheets",
          "bamboo-sheets-desktopmockup",
          "pillowcase",
          "fitted-sheet",
        ];
        const handle = window.theme.product?.handle;
        const template = window.theme.product?.template;
        if (!handles.includes(handle) && !templates.includes(template)) {
          return false;
        }
        const normalized = this.normalizeOptionValue(value)
          .toLowerCase()
          .replace(/\s+/g, "");
        return (
          normalized === "caliking" ||
          normalized === "californiaking" ||
          normalized === "twin" ||
          normalized === "full"
        );
      }
      getBeddingBundleSizeOptionName() {
        const option = window.theme.product?.options?.[1];
        return typeof option === "string" ? option : option?.name;
      }
      getBedSizeInputLabel(input) {
        return (
          input.nextElementSibling ||
          this.querySelector(`label[for="${input.id}"]`)
        );
      }
      updateBeddingBundleSizes() {
        if (!this.isBeddingBundleProduct()) return false;

        const sizeOptionName = this.getBeddingBundleSizeOptionName();
        if (!sizeOptionName) return false;

        const sizeContainer = this.querySelector(".js-bedding-bundle-sizes");
        if (!sizeContainer) return false;

        const sizeInputs = [
          ...sizeContainer.querySelectorAll(
            'input[name="' + sizeOptionName + '"]'
          ),
        ];
        if (!sizeInputs.length) return false;

        const selectedColor =
          this.options?.[0] ||
          this.currentVariant?.options?.[0] ||
          this.swatch?.querySelector('input[name="Color"]:checked')?.value;

        let selectedStillVisible = false;
        let firstVisibleInput = null;

        sizeInputs.forEach((input) => {
          const label = this.getBedSizeInputLabel(input);
          let visible = true;

          if (this.isHiddenBeddingSize(input.value)) {
            visible = false;
          } else if (selectedColor) {
            visible = window.theme.product.variants.some(
              (variant) =>
                this.normalizeOptionValue(variant.options[0]) ===
                  this.normalizeOptionValue(selectedColor) &&
                this.normalizeOptionValue(variant.options[1]) ===
                  this.normalizeOptionValue(input.value)
            );
          }

          if (visible) {
            label?.removeAttribute("hidden");
            label?.style.removeProperty("display");
            input.disabled = false;
            if (!firstVisibleInput) firstVisibleInput = input;
            if (input.checked) selectedStillVisible = true;
          } else {
            input.disabled = true;
            if (input.checked) input.checked = false;
            label?.setAttribute("hidden", "");
          }
        });

        if (!selectedStillVisible && firstVisibleInput) {
          firstVisibleInput.checked = true;
          this.updateOptions();
          const matched = window.theme.product.variants.find(
            (variant) =>
              !variant.options
                .map((opt, i) => this.options[i] === opt)
                .includes(false)
          );
          if (matched) this.currentVariant = matched;
        }

        return false;
      }
      normalizeOptionValue(value) {
        return String(value)
          .replace(/\u2019/g, "'")
          .replace(/\u2018/g, "'")
          .trim();
      }
      optionsMatch(variantOptions, selectedOptions) {
        return variantOptions.every((opt, index) => {
          const selected = selectedOptions[index];
          if (!selected) return false;
          return (
            this.normalizeOptionValue(opt) ===
            this.normalizeOptionValue(selected)
          );
        });
      }
      findCuddlerCoverVariant() {
        if (!this.isCuddlerCoverProduct()) {
          return this.currentVariant;
        }
        const variants = window.theme.product.variants;
        let match = variants.find((variant) =>
          this.optionsMatch(variant.options, this.options)
        );
        if (match) return match;

        if (this.options[0]) {
          match = variants.find(
            (variant) =>
              variant.available &&
              this.normalizeOptionValue(variant.options[0]) ===
                this.normalizeOptionValue(this.options[0]) &&
              (!this.options[1] ||
                this.normalizeOptionValue(variant.options[1]) ===
                  this.normalizeOptionValue(this.options[1])) &&
              (!this.options[2] ||
                this.normalizeOptionValue(variant.options[2]) ===
                  this.normalizeOptionValue(this.options[2]))
          );
          if (match) return match;

          match = variants.find(
            (variant) =>
              variant.available &&
              this.normalizeOptionValue(variant.options[0]) ===
                this.normalizeOptionValue(this.options[0])
          );
          if (match) return match;
        }

        return (
          variants.find((variant) => variant.available && variant.price > 0) ||
          variants[0]
        );
      }
      updateMasterId() {
        const t = window.theme.hideUnavailableWeights,
          e = this.currentVariant.sizes.join(",");
        const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                           (window.theme.product && window.theme.product.handle === 'body-pillow');

        if (this.isWeightLandingPage() || window.theme.product.landing) {
          this.updateWeightLandingVariant();
          return;
        }

        if (this.isCuddlerCoverProduct()) {
          this.currentVariant = this.findCuddlerCoverVariant();
        } else if (
          ((this.currentVariant = window.theme.product.variants.find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
          )),
          this.currentVariant ||
            (this.currentVariant = window.theme.product.variants.find(
              (t) => t.options[0] === this.options[0]
            )),
          t &&
            "Color" === window.theme.product.options[0] &&
            "Weight (lbs)" === window.theme.product.options[1])
        ) {
          this.setAttribute("data-hide-weights", "true");
          const t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          
          if (0 === t.length) return;
          
          for (var i = 0; i < t.length; i++) {
            var r = t[i];
            const e = r.value;
            var o = r.nextElementSibling;
            
            const availableVariant = window.theme.product.variants.find(
              function (variant) {
                return (
                  variant.options[1] === e &&
                  variant.options[0] === this.currentVariant?.options?.[0] &&
                  variant.available
                );
              }.bind(this)
            );
            
            availableVariant
              ? o.removeAttribute("hidden")
              : o.setAttribute("hidden", "");
          }
          const weightLabel = this.querySelector(
            'input[name="' +
              window.theme.product.options[1] +
              '"] + label:not([hidden])'
          );
          // Avoid label.click() — it re-enters onVariantChange and doubles INP cost
          if (!this.currentVariant?.available && weightLabel) {
            const weightInput = weightLabel.previousElementSibling;
            if (weightInput?.tagName === "INPUT" && !weightInput.checked) {
              weightInput.checked = true;
              this.updateOptions();
              const matched = window.theme.product.variants.find(
                (variant) =>
                  !variant.options
                    .map((opt, i) => this.options[i] === opt)
                    .includes(false)
              );
              if (matched) this.currentVariant = matched;
            }
          }
        } else if (
          !window.theme.product.landing &&
          !this.isBodyPillowProduct() &&
          !this.isCuddlerCoverProduct() &&
          !this.isBeddingBundleProduct() &&
          this.currentVariant.sizes.join(",") !== e
        ) {
          const sizeInput = this.querySelector(
            'input[value="' + this.currentVariant.options[1] + '"]'
          );
          if (sizeInput && !sizeInput.checked) sizeInput.checked = true;
          this.options = this.currentVariant.options;
          const weightOptionName =
            (window.theme.product.options || []).find((name) =>
              String(name).includes("Weight")
            ) || window.theme.product.options[1];
          let t = this.querySelectorAll(
            'input[name="' + weightOptionName + '"]'
          );
          if (0 === t.length) return;
          for (let e = 0; e < t.length; e++) {
            const i = t[e],
              r = i.nextElementSibling;
            const visible = this.isHiddenBeddingSize(i.value)
              ? false
              : this.shouldShowAllSizes()
              ? window.theme.product.variants.some(
                  (variant) =>
                    variant.options[0] === this.currentVariant?.options?.[0] &&
                    variant.options[1] === i.value
                )
              : this.currentVariant.sizes.includes(i.value);
            visible
              ? r.removeAttribute("hidden")
              : r.setAttribute("hidden", "");
          }
        }

        this.ensureLargeCuddlerVariant();
        this.clearBodyPillowMaterialHidden();
      }
   updateMedia() {
  if ("Sleeper" !== window.theme.product.title) {

    if ("Gift Card" === window.theme.product.type) {
      const t = window.theme.product.images[this.currentVariant.color][1];
      this.image.src = t.src;
      this.image.alt = t.alt;
      this.updateGallery(window.theme.product.images[this.currentVariant.color]);
    } else {

      const isOceanNapper =
        window.location.pathname.includes('ocean-napper') ||
        (window.theme.product && window.theme.product.handle === 'ocean-napper');

      const isHuggerSelected =
        isOceanNapper &&
        this.currentVariant.options &&
        (this.currentVariant.options.includes('Queen 20') ||
         this.currentVariant.options.includes('King 25'));

      const isBodyPillow =
        window.location.pathname.includes('body-pillow') ||
        (window.theme.product && window.theme.product.handle === 'body-pillow');
        // alert(isBodyPillow);

      let t;

      // =============================
      //  BODY PILLOW (STRICT FIX)
      // =============================
if (isBodyPillow) {

  let color = '';
  let size = '';
  let material = '';

  this.currentVariant.options.forEach(opt => {
    const val = opt.toLowerCase();

    if (val.includes('54')) size = '54';
    else if (val.includes('75')) size = '75';
    else if (val.includes('linen')) material = 'linen';
    else if (val.includes('cotton')) material = 'cotton';
    else color = val.replace(/\s+/g, '-');
  });

  let allImages = [];

  if (window.theme.product.landing) {
    allImages = Object.values(window.theme.product.images[this.currentVariant.product] || {}).flat();
  } else {
    allImages = Object.values(window.theme.product.images || {}).flat();
  }

  const sizeRegex = new RegExp(`_${size}([_\\.])`);

  // FILTER → color + size + material
  t = allImages.filter(img => {
    const src = img.src.toLowerCase();

    return (
      src.includes(color) &&
      sizeRegex.test(src) &&
      (material ? src.includes(material) : true)
    );
  });

  // fallback 1 → color + size
  if (!t || t.length === 0) {
    t = allImages.filter(img => {
      const src = img.src.toLowerCase();
      return src.includes(color) && sizeRegex.test(src);
    });
  }

  // fallback 2 → only color
  if (!t || t.length === 0) {
    t = allImages.filter(img => {
      return img.src.toLowerCase().includes(color);
    });
  }

  // =============================
  // IMPORTANT FIX (MODAL + VIDEO SYNC)
  // =============================

  // store filtered images TEMPORARILY (not globally)
  this._filteredImages = t;

  // console.log('BODY PILLOW FINAL:', t.map(i => i.src));
}
      // =============================
      //  OTHER PRODUCTS (UNCHANGED)
      // =============================
      if (isBodyPillow && t && t.length) {
        // do nothing
      }
      else if (isHuggerSelected) {

        const huggerColorKey = 'hugger-' + this.currentVariant.color;

        t = window.theme.product.landing
          ? window.theme.product.images[this.currentVariant.product][huggerColorKey]
          : window.theme.product.images[huggerColorKey];

        if (!t) {
          t = window.theme.product.landing
            ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
            : window.theme.product.images[this.currentVariant.color];
        }

      }
      else {

        t = window.theme.product.landing
          ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
          : window.theme.product.images[this.currentVariant.color];

        // Pillowcase / multi-word colors: try underscore key + filename match
        if ((!t || !t.length) && this.currentVariant.color && window.theme.product.images) {
          const imageMap = window.theme.product.landing
            ? window.theme.product.images[this.currentVariant.product] || {}
            : window.theme.product.images;
          const colorKey = String(this.currentVariant.color).toLowerCase();
          const colorUnderscore = colorKey.replace(/-/g, '_');

          t = imageMap[colorUnderscore] || imageMap[colorKey] || t;

          if ((!t || !t.length) && imageMap && typeof imageMap === 'object') {
            const matched = Object.keys(imageMap).reduce((acc, key) => {
              const k = String(key).toLowerCase();
              const keyMatches =
                k === colorKey ||
                k === colorUnderscore ||
                k.startsWith(colorKey + '-') ||
                k.startsWith(colorUnderscore + '_') ||
                k.startsWith(colorUnderscore + '-') ||
                k.includes(colorKey) ||
                k.includes(colorUnderscore);
              if (keyMatches && Array.isArray(imageMap[key])) {
                return acc.concat(imageMap[key]);
              }
              return acc;
            }, []);
            if (matched.length) t = matched;
          }

          if ((!t || !t.length) && imageMap && typeof imageMap === 'object') {
            const allImages = Object.values(imageMap).flat().filter(Boolean);
            const filtered = allImages.filter((img) => {
              const src = String(img.src || '').toLowerCase().replace(/_/g, '-');
              return (
                src.includes(colorKey) ||
                src.includes(colorUnderscore.replace(/_/g, '-'))
              );
            });
            if (filtered.length) t = filtered;
          }
        }

      }

      // =============================
      //  UPDATE GALLERY
      // =============================
      if ((!t || !t.length) && window.theme.product.images) {
        const imageMap = window.theme.product.landing
          ? window.theme.product.images[this.currentVariant.product] || {}
          : window.theme.product.images;
        t =
          Object.values(imageMap).find(
            (group) => Array.isArray(group) && group.length
          ) || [];
      }
      if (t && t.length) {
        const isDesktop = window.matchMedia("(min-width: 750px)").matches;

        // Only rebuild the gallery that is currently visible — rebuilding both
        // mobile slider + desktop grid on every swatch tap is a major INP cost.
        if (isDesktop) {
          if (this.nGallery && this.nGallery.dataset.slider !== "true") {
            this.updateGallery(t);
          } else if (this.gallery2) {
            this.gallery2.update(t, window.theme.product.video);
          }
        } else if (this.gallery) {
          this.gallery.update(t, window.theme.product.video);
        }
      }
    }

    this.imageBar.src = this.currentVariant.image;

    if (window.theme.product.videoObserverInit) {
      window.theme.product.videoObserverInit();
    }
  }
}
      updateGallery(t) {
        if (!this.nGallery || "true" === this.nGallery.dataset.slider || 0 === t.length)
          return;
        const awardHandles = ["the-napper", "tree-napper"];
        const awardHideColors = (window.theme.pdpAwardHideColors || []).map((color) =>
          String(color).trim().toLowerCase()
        );
        const checkedColor = document.querySelector(
          '.swatch-color input[type="radio"]:checked, .swatch-colour input[type="radio"]:checked'
        );
        const selectedColor = String(
          checkedColor?.value || this.currentVariant?.options?.[0] || ""
        )
          .trim()
          .toLowerCase();
        const hideForColor =
          selectedColor !== "" && awardHideColors.includes(selectedColor);
        const showAwards =
          awardHandles.includes(window.theme.product?.handle) && !hideForColor;
        let awardTpl = document.querySelector(".js-pdp-award-overlay-template");
        if (showAwards && awardTpl && !awardTpl.dataset.preserved) {
          const keep = document.createElement("template");
          keep.className = "js-pdp-award-overlay-template";
          keep.dataset.preserved = "true";
          keep.innerHTML = awardTpl.innerHTML;
          document.body.appendChild(keep);
          awardTpl = keep;
        }
        const awardHTML =
          showAwards && awardTpl ? awardTpl.innerHTML : "";
        let e = "";
        t.forEach(function (img, i) {
          const award = i === 0 && awardHTML ? awardHTML : "";
          e += `\n      <div class="product-gallery_item product-gallery_item-image pointer${
            i === 0 && awardHTML ? " has-pdp-award" : ""
          }">  \n        <div class="media media--square">${award}\n          <img src="${img.src}" alt="${img.alt}" width="800" height="1000" class="cover-image" loading="lazy" onclick="window.theme.product.modal(${i})">\n        </div>\n      </div>`;
        }),
          window.theme.product.video
            ? (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${window.theme.product.video.image}" onclick="window.theme.product.modal(${t.length})">\n          <source src="${window.theme.product.video.src}" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`)
            : window.theme.product.videos &&
              window.theme.product.videos[this.currentVariant.product] &&
              (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${
                window.theme.product.videos[this.currentVariant.product].image
              }" onclick="window.theme.product.modal(${
                t.length
              })">\n          <source src="${
                window.theme.product.videos[this.currentVariant.product].src
              }" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`),
          (this.nGallery.innerHTML = e);
      }
      updateURL() {
        if (window.theme.product.landing) return;
        const isSecondSkinPdp =
          document.body.classList.contains("second-skin-pdp");
        const isFirstLoad = this.firstLoad;
        if (isFirstLoad && !isSecondSkinPdp) {
          this.firstLoad = !1;
          return;
        }
        if (isFirstLoad) this.firstLoad = !1;
        const t = new URLSearchParams(window.location.search);
        t.set("variant", this.currentVariant.id);
        const e = window.location.pathname + "?" + t.toString();
        // replaceState avoids history spam + cheaper than pushState on rapid swatch taps
        history.replaceState(null, "", e);
      }
      updateVariantInput() {
        if (!this.input) {
          this.input = this.form?.querySelector('input[name="id"]');
        }
        if (!this.input) return;
        (this.input.value = this.currentVariant.id),
          this.input.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      checkAvailability() {
        const isBeddingBundle = this.isBeddingBundleProduct();
        const isWeightLanding = this.isWeightLandingPage();
        const isSecondSkinPdp = document.body.classList.contains("second-skin-pdp");
        const bisTrigger = isBeddingBundle
          ? this.querySelector(".js-bedding-bundle-waitlist")
          : isWeightLanding
          ? this.querySelector(".js-weight-lp-waitlist")
          : isSecondSkinPdp
          ? this.querySelector(".js-second-skin-waitlist")
          : this.querySelector(".klaviyo-bis-trigger");

        if (this.currentVariant.available) {
          this.removeAttribute("soldout");
          if (!isBeddingBundle && bisTrigger) bisTrigger.style.display = "none";
        } else {
          this.setAttribute("soldout", "");
          if (!isBeddingBundle && bisTrigger) bisTrigger.style.display = "block";
        }

        if (isBeddingBundle) {
          const shopBarToggle = document.getElementById("shop-bar-toggle-mobile");
          if (shopBarToggle) {
            shopBarToggle.classList.toggle(
              "d-none",
              !this.currentVariant.available
            );
          }
        }

        if (isWeightLanding) {
          const shopBarToggle = document.getElementById("shop-bar-toggle-mobile");
          if (shopBarToggle) {
            shopBarToggle.classList.toggle(
              "d-none",
              !this.currentVariant.available
            );
          }
        }
      }

      changeElements() {
        var additionalText = document.getElementById('product-form_additional-text');
        const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                           (window.theme.product && window.theme.product.handle === 'body-pillow');
        const preorderText = document.querySelector('#product-form_preorder-text');
        if (window.theme.product.currentVariant.is_preoder === "true") {
          if (preorderText) {
            preorderText.style.display = 'block';
            preorderText.innerHTML = window.theme.product.currentVariant.preorder_text;
          }
          if (this.button) this.button.innerHTML = "PRE-ORDER";
        } 
        else {
          if (preorderText) preorderText.style.display = 'none';
          if (this.button) this.button.innerHTML = "ADD TO CART";
          if (additionalText) additionalText.style.display = 'block';

        }
        const comparePriceEls = document.querySelectorAll(
            ".product-price-compare.compare-price"
          ),
          saveTagEls = document.querySelectorAll(".tag--save"),
          originalPriceEls = document.querySelectorAll(".compare-price-cart.product-price");
        const salePrice = this.currentVariant.price;
        const originalPrice = this.currentVariant.compare_at_price || salePrice;
        const parsePriceAmount = (price) =>
          parseFloat(String(price).replace(/[^0-9.-]+/g, ""));
        let hasSpecialDiscount = !1;
        var n = 0;

        (
          comparePriceEls.forEach((compareEl) => {
            if (window.theme.product.sku_discounts == true) {
              if (window.theme.product.currentVariant.discount != "") {
                const isFixedDiscount = window.theme.product.currentVariant.is_fixed_discount;
                const originalAmount = parsePriceAmount(originalPrice);
                const saleAmount = parsePriceAmount(salePrice);

                if (originalAmount > 0) {
                  n = saleAmount / originalAmount;
                }

                saveTagEls.forEach((saveEl) => {
                  saveEl.dataset.textDiscount = isFixedDiscount
                    ? "$" + window.theme.product.currentVariant.discount + " off"
                    : window.theme.product.currentVariant.discount + "% off";
                  saveEl.style.display = "flex";
                });
                originalPriceEls.forEach((originalEl) => {
                  originalEl.style.display = "";
                  originalEl.innerHTML = originalPrice;
                });
                const discountWrapper = document.querySelector(
                  ".discount-additional-text-wrapper"
                );
                if (discountWrapper) discountWrapper.style.display = "block";
                if (this.save_additional) {
                  this.save_additional.innerHTML = isFixedDiscount
                    ? "Save $" + window.theme.product.currentVariant.discount + " "
                    : "Save " + window.theme.product.currentVariant.discount + "% ";
                }
                compareEl.classList.add("red"),
                  (compareEl.innerHTML = salePrice),
                  (this.button.dataset.mobilePrice = salePrice),
                  (this.button.setAttribute("data-mobile-price", salePrice));
              } else {
                saveTagEls.forEach((saveEl) => {
                  saveEl.style.display = "none";
                });
                compareEl.innerHTML = salePrice;
                compareEl.classList.remove("red");
                originalPriceEls.forEach((originalEl) => {
                  originalEl.style.display = "none";
                });
                const discountWrapper = document.querySelector(".discount-additional-text-wrapper");
                if (discountWrapper) {
                  discountWrapper.style.display = "none";
                }
                this.button.dataset.mobilePrice = salePrice;
              }
            } else {
              const originalAmount = parsePriceAmount(salePrice);
              this.specialDiscount.forEach((specialEl) => {
                if (specialEl.innerHTML == window.theme.product.currentVariant.id)
                  return (
                    (n = 1 - specialEl.dataset.specialDiscount / 100),
                    compareEl.classList.add("red"),
                    (document.querySelector(
                      ".discount-additional-text-wrapper"
                    ).style.display = "block"),
                    (this.save_additional.style.display = "inline-block"),
                    (originalPriceEls[0].style.display = "block"),
                    saveTagEls.forEach((saveTagEl) => {
                      (saveTagEl.dataset.textDiscount =
                        specialEl.dataset.specialDiscount + "% off"),
                        (saveTagEl.style.display = "flex"),
                        (this.save_additional.innerHTML =
                          "Save " + specialEl.dataset.specialDiscount + "% ");
                    }),
                    void (hasSpecialDiscount = !0)
                  );
              }),
                hasSpecialDiscount ||
                  (() => {
                    const isFixed = compareEl.dataset.isFixed === "true";
                    let discountedPrice;

                    if (isFixed) {
                      const discountAmount = parseFloat(compareEl.dataset.discount) * 100;
                      discountedPrice = originalAmount - discountAmount;
                      n = discountedPrice / originalAmount;
                    } else {
                      n = 1 - compareEl.dataset.discount / 100;
                      discountedPrice = originalAmount * n;
                    }

                    compareEl.classList.add("red");
                    document.querySelector(".discount-additional-text-wrapper").style.display = "block";
                    this.save_additional.style.display = "inline-block";
                    originalPriceEls[0].style.display = "block";
                    this.save_additional.innerHTML = isFixed
                      ? "Save $" + compareEl.dataset.discount + " "
                      : "Save " + compareEl.dataset.discount + "% ";
                    saveTagEls.forEach((saveTagEl) => {
                      saveTagEl.dataset.textDiscount = isFixed
                        ? "$" + compareEl.dataset.discount + " off"
                        : compareEl.dataset.discount + "% off";
                      saveTagEl.style.display = "flex";
                    });
                    compareEl.innerHTML = `$${Math.round(discountedPrice)}`;
                    this.button.dataset.mobilePrice = `$${Math.round(discountedPrice)}`;
                  })();
            }
          }),
          this.prices.forEach((priceEl) => {
            if (priceEl.classList.contains("compare-price-cart")) {
              const showCompare =
                window.theme.product.sku_discounts &&
                this.currentVariant.discount !== "" &&
                this.currentVariant.compare_at_price &&
                this.currentVariant.compare_at_price !== salePrice;
              priceEl.innerHTML = showCompare ? originalPrice : salePrice;
              return;
            }
            priceEl.innerHTML = salePrice;
          }),
          this.priceDiscount.forEach((t) => {
            let e = parsePriceAmount(salePrice),
              i = Math.ceil(1.11 * e);
            t.innerHTML = "$" + i.toFixed(0);
          }),
          this.SignButton &&
            (this.SignButton.dataset.unitPrice = salePrice),
          this.button &&
            ((this.button.dataset.bundlePrice = salePrice),
            (this.button.dataset.unitPrice = salePrice))
        );
        if (this.isWeightLandingPage() || window.theme.product.landing) {
          this.updateWeightLandingLabels();
        } else if (
          window.theme.product.options[1] &&
          window.theme.product.options[1].includes("Weight")
        ) {
          this.option1 &&
            (this.option1.innerHTML =
              window.theme.product.title === "Cuddler"
                ? this.currentVariant.options[0]
                    .replaceAll("Body Pillow", "")
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .trim()
                : this.currentVariant.options[0]),
            this.option3 &&
              (this.option3.innerHTML = this.currentVariant.options[2]),
            this.option2 &&
              (this.option2.innerHTML =
                this.currentVariant.options[1]
                  .replace("Queen ", "")
                  .replace("King ", "") +
                " lbs " +
                window.theme.getDimension(this.currentVariant.options[1]));
        } else if (
          "Size" === window.theme.product.options[0] &&
          "Sleeper" === window.theme.product.title
        ) {
          this.option1 &&
            (this.option1.innerHTML =
              this.currentVariant.options[0] +
              window.theme.getDimension(this.currentVariant.options[0]));
        } else if (
          window.theme.product.template === "pillowcase" ||
          window.theme.product.template === "product.pillowcase" ||
          window.theme.product.template === "fitted-sheet" ||
          window.theme.product.template === "product.fitted-sheet" ||
          window.theme.product.handle === "pillow-case" ||
          window.theme.product.handle === "pillowcase" ||
          window.theme.product.handle === "fitted-sheet"
        ) {
          // Pillowcase: Color/Size order can vary — never append dims to the Size name
          const optionNames = window.theme.product.options || [];
          const sizeIndex = optionNames.findIndex(
            (name) => String(name).toLowerCase() === "size"
          );
          optionNames.forEach((name, idx) => {
            const el = this[`option${idx + 1}`];
            if (!el || this.currentVariant.options[idx] == null) return;
            el.textContent = this.currentVariant.options[idx];
          });
          const dimEl =
            this.querySelector("[data-pillowcase-size-dim]") ||
            document.querySelector("[data-pillowcase-size-dim]");
          if (dimEl && sizeIndex >= 0) {
            dimEl.textContent = window.theme.getDimension(
              this.currentVariant.options[sizeIndex]
            );
          }
        } else if (
          window.theme.product.options[1] &&
          "Size" === window.theme.product.options[1] &&
          "Gift Card" !== window.theme.product.type
        ) {
          let t = this.currentVariant.options[1];
          "Small" === t && "Pupper Pod" === window.theme.product.title
            ? (t = "Small1")
            : "Medium" === t &&
              "Pupper Pod" === window.theme.product.title &&
              (t = "Medium1"),
            this.option2 &&
              (this.option2.innerHTML =
                this.currentVariant.options[1] + window.theme.getDimension(t));
          if (
            this.option1 &&
            window.theme.product.options[0] === "Color"
          ) {
            this.option1.innerHTML = this.currentVariant.options[0];
          }
        } else {
          this.option1 &&
            (this.option1.innerHTML =
              window.theme.product.title === "Cuddler"
                ? this.currentVariant.options[0]
                    .replaceAll("Body Pillow", "")
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .trim()
                : this.currentVariant.options[0]),
            this.option2 &&
              (this.option2.innerHTML = this.currentVariant.options[1]);
          if (this.option3 && this.currentVariant.options[2] != null) {
            this.option3.innerHTML = this.currentVariant.options[2];
          }
        }
        if (
          (!this.isWeightLandingPage() &&
            this.option0 &&
            ((this.option0.innerHTML = this.currentVariant.product),
            (this.option0.href =
              window.theme.product.urls[this.currentVariant.product] || "")),
          window.theme.extraColors && this.productLabel)
        ) {
          const t = window.theme.extraColors.includes(
              this.currentVariant.options[0]
            ),
            e = this.option1
              .closest(".form__label")
              .classList.contains("form__label--2");
          t && !e
            ? (this.swatch
                .querySelector(".form__label--2")
                .appendChild(this.option1),
              this.swatch
                .querySelector(".form__label--2")
                .appendChild(this.productLabel))
            : !t &&
              e &&
              (this.swatch
                .querySelector(".form__label--1")
                .appendChild(this.option1),
              this.swatch
                .querySelector(".form__label--1")
                .appendChild(this.productLabel));
        }
        this.updateDetailsTab();
      }
      updateDetailsTab() {
        const tab = document.querySelector(".details-tab");
        if (!tab || !window.theme?.product) return;

        const variantDetails = this.currentVariant?.details;
        const detailsHtml =
          variantDetails && String(variantDetails).trim()
            ? variantDetails
            : window.theme.product.details || "";
        if (!detailsHtml) return;

        const layout = tab.dataset.detailsLayout || "default";
        const splitSection = (html, heading) => {
          const marker = `<h5>${heading}</h5>`;
          if (!html.includes(marker)) return "";
          return html.split(marker).pop().split("<h5>")[0];
        };

        const productInformation = detailsHtml.split("<h5>")[0] || "";
        let materials = "";
        let care = "";
        let benefits = "";
        let specs = "";
        let warranty = "";
        let hasSpecs = false;
        let hasWarranty = detailsHtml.includes("<h5>Warranty</h5>");

        if (layout === "landing") {
          materials = splitSection(detailsHtml, "Care");
          care = splitSection(detailsHtml, "FAQ");
          warranty = splitSection(detailsHtml, "Warranty");
        } else if (layout === "sheets") {
          benefits = splitSection(detailsHtml, "Benefits");
          materials = splitSection(detailsHtml, "Materials");
          care = detailsHtml.includes("<h5>Care Instructions</h5>")
            ? splitSection(detailsHtml, "Care Instructions")
            : splitSection(detailsHtml, "Care");
          warranty = splitSection(detailsHtml, "Warranty");
          specs = splitSection(detailsHtml, "Specs");
          hasSpecs = detailsHtml.includes("<h5>Specs</h5>") && !!specs.trim();
          hasWarranty = hasWarranty && !!warranty.trim();
        } else {
          materials = splitSection(detailsHtml, "Materials");
          care = splitSection(detailsHtml, "Care Instructions");
          specs = splitSection(detailsHtml, "Specs");
          warranty = splitSection(detailsHtml, "Warranty");
          hasSpecs = detailsHtml.includes("<h5>Specs</h5>");
        }

        if (!hasWarranty || !warranty.trim()) {
          warranty = `<p>Our products are handmade with care, and excellent craftsmanship is woven into everything we do. That’s why we offer a 1-year warranty on our ${window.theme.product.title} — so you can rest easy knowing we’ve got you covered.</p>`;
        }

        const setPanel = (id, html) => {
          const el = document.getElementById(id);
          if (el) el.innerHTML = html;
        };

        const toggleSection = (id, show) => {
          const panel = document.getElementById(id);
          const trigger = document.querySelector(
            `.details-tab [data-tab-target="#${id}"]`
          );
          if (trigger) {
            if (show) trigger.removeAttribute("hidden");
            else trigger.setAttribute("hidden", "");
          }
          if (panel) {
            const accordionItem = panel.closest(".details-tab__accordion-item");
            if (accordionItem) {
              accordionItem.style.display = show ? "" : "none";
            } else if (show) {
              panel.removeAttribute("hidden");
            } else {
              panel.setAttribute("hidden", "");
            }
          }
        };

        setPanel("details", productInformation);
        setPanel("materials", materials);
        setPanel("care", care);
        if (layout === "sheets") setPanel("benefits", benefits);
        setPanel("specs", specs);
        setPanel("warranty", warranty);

        if (layout === "default" || layout === "sheets") {
          toggleSection("specs", hasSpecs);
        }
        if (layout === "sheets") {
          toggleSection("warranty", hasWarranty);
        }
      }
      handleSelect(t) {
        "INPUT" !== t.target.tagName &&
          (this.select.hasAttribute("open")
            ? this.select.removeAttribute("open")
            : this.select.setAttribute("open", ""));
      }
      handleLpColors() {
        if (!this.isWeightLandingPage()) return;

        this.updateWeightLandingColorVisibility();
        if (this.syncWeightLandingSelection()) {
          this.updateOptions();
          this.updateWeightLandingVariant();
          this.updateVariantInput();
          window.theme.product.currentVariant = this.currentVariant;
        }
        this.updateWeightLandingLabels();
      }
    }
    customElements.define("product-form", t);
    
            (function () {
                var t = document.querySelector("#product-zoom-modal");
                if (t) {
                  const r = t.querySelector("img"),
                    o = t.querySelector("video"),
                    n = t.querySelector(".slider-next"),
                    s = t.querySelector(".slider-prev"),
                    closeButton = t.querySelector(".icon-cross");
                  const isLatexPillow =
                    window.theme.product &&
                    window.theme.product.template === "latex-pillow";

                  function getRenderedGalleryMedia() {
                    const gallery =
                      document.querySelector(
                        ".product-gallery-grid slider-component:not([hidden])"
                      ) ||
                      document.querySelector(
                        ".product-gallery-grid slider-component"
                      );

                    if (!gallery) return [];

                    return Array.from(
                      gallery.querySelectorAll(
                        ".slider-slide, .splide__slide"
                      )
                    )
                      .map((slide) => {
                        const video = slide.querySelector("video");
                        if (video) {
                          const source = video.querySelector("source");
                          return {
                            type: "video",
                            src:
                              video.currentSrc ||
                              (source ? source.src : ""),
                            mimeType: source ? source.type : "video/mp4",
                            poster: video.poster || "",
                          };
                        }

                        const image = slide.querySelector("img.cover-image");
                        if (!image) return null;

                        return {
                          type: "image",
                          src: image.currentSrc || image.src,
                          alt: image.alt || "",
                        };
                      })
                      .filter(Boolean);
                  }

                  function showLatexModalMedia(media, index) {
                    const item = media[index];
                    if (!item) return false;

                    if (item.type === "video" && o) {
                      const source = o.querySelector("source");
                      r.setAttribute("hidden", "");
                      o.removeAttribute("hidden");
                      o.poster = item.poster;
                      if (source && source.src !== item.src) {
                        source.src = item.src;
                        source.type = item.mimeType;
                        o.load();
                      }
                      const playPromise = o.play();
                      if (playPromise !== undefined) {
                        playPromise.catch(() => {});
                      }
                    } else {
                      if (o) {
                        o.pause();
                        o.setAttribute("hidden", "");
                      }
                      r.removeAttribute("hidden");
                      r.src = item.src.replace("_800x", "");
                    }

                    r.dataset.index = index.toString();
                    return true;
                  }

                  function closeZoomModal() {
                    t.removeAttribute("open");
                    document.body.classList.remove("body_fade");
                    document.body.classList.remove("header_fade");
                    if (o && !o.paused) {
                      o.pause();
                    }
                  }

                    function e(direction) {
          let images;
          let index = parseInt(r.dataset.index);

          if (isLatexPillow) {
            const media = getRenderedGalleryMedia();
            if (!media.length) return;

            if (direction === "next") {
              index = index >= media.length - 1 ? 0 : index + 1;
            } else {
              index = index <= 0 ? media.length - 1 : index - 1;
            }

            showLatexModalMedia(media, index);
            return;
          }

          const formEl = document.querySelector('product-form');
          const isBodyPillow =
            window.location.pathname.includes('body-pillow') ||
            (window.theme.product && window.theme.product.handle === 'body-pillow');

          //  USE FILTERED IMAGES
          if (isBodyPillow && formEl && formEl._filteredImages?.length) {
            images = formEl._filteredImages;
          } else {
            images = window.theme.product.landing
              ? window.theme.product.images[
                  window.theme.product.currentVariant.product
                ][window.theme.product.currentVariant.color]
              : "Sleeper" === window.theme.product.title
              ? window.theme.product.images.sleeper
              : window.theme.product.images[
                  window.theme.product.currentVariant.color
                ];
          }

          if (!images || !images.length) return;

          const lastIndex = images.length - 1;

          // VIDEO LOGIC
          if (o && ((direction === "next" && index === lastIndex) || (direction === "prev" && index === 0))) {
            o.removeAttribute("hidden");
            const playPromise = o.play();
            if (playPromise !== undefined) playPromise.catch(() => {});
            r.dataset.index = images.length.toString();
            return;
          }

          // NORMAL NAV
          if (direction === "next") {
            index = index >= lastIndex ? 0 : index + 1;
          } else {
            index = index === 0 ? lastIndex : index - 1;
          }

          r.src = "";
          if (o && !o.paused) {
            o.pause();
            o.setAttribute("hidden", "");
          }

          r.src = images[index].src.replace("_800x", "");
          r.dataset.index = index.toString();
        }

          // function e(t) {
          //   let e,
          //     i = parseInt(r.dataset.index);
          //   e = window.theme.product.landing
          //     ? window.theme.product.images[
          //         window.theme.product.currentVariant.product
          //       ][window.theme.product.currentVariant.color]
          //     : "Sleeper" === window.theme.product.title
          //     ? window.theme.product.images.sleeper
          //     : window.theme.product.images[
          //         window.theme.product.currentVariant.color
          //       ];
          //   const n = e.length - 1
          //   if (o && (("next" === t && i === n) || ("prev" === t && 0 === i))) {
          //     o.removeAttribute("hidden");
          //     const t = o.play();
          //     return (
          //       void 0 !== t &&
          //         t.catch(function (t) {
          //           /* removed console.log */
          //         }),
          //       void (r.dataset.index = e.length.toString())
          //     );
          //   }
          //   "next" === t
          //     ? i >= n
          //       ? (i = 0)
          //       : i++
          //     : "prev" === t && (0 === i ? (i = n) : i--),
          //     (r.src = ""),
          //     o && !o.paused && (o.pause(), o.setAttribute("hidden", "")),
          //     (r.src = e[i].src),
          //     (r.dataset.index = i.toString());
          // }
          (window.theme.product.modal = function (e) {
              let i;

              if (isLatexPillow) {
                const media = getRenderedGalleryMedia();
                const modalIndex = e > 0 ? e - 1 : 0;
                if (!showLatexModalMedia(media, modalIndex)) return;

                document.body.classList.add("body_fade");
                document.body.classList.add("header_fade");
                t.setAttribute("open", "");
                return;
              }

              // get filtered images from product-form (ONLY for body pillow)
              const formEl = document.querySelector('product-form');
              const isBodyPillow =
                window.location.pathname.includes('body-pillow') ||
                (window.theme.product && window.theme.product.handle === 'body-pillow');

              if (isBodyPillow && formEl && formEl._filteredImages && formEl._filteredImages.length) {
                i = formEl._filteredImages; // use filtered images
              } else {
                // fallback (unchanged for other products)
                i = window.theme.product.landing
                  ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                  : "Sleeper" === window.theme.product.title
                  ? window.theme.product.images.sleeper
                  : window.theme.product.images[this.currentVariant.color];
              }

              if (i) {
                const modalIndex = e;

                if (modalIndex === i.length) {
                  o.removeAttribute("hidden");
                  const t = o.play();
                  if (t !== undefined) {
                    t.catch(function () {});
                  }
                } else {
                  r.src = "";
                  if (o && !o.paused) {
                    o.pause();
                    o.setAttribute("hidden", "");
                  }

                  const t = i[modalIndex];
                  if (!t) return;
                  r.src = t.src.replace("_800x", "");
                }

                r.dataset.index = modalIndex.toString();
                document.body.classList.add("body_fade");
                document.body.classList.add("header_fade");
                t.setAttribute("open", "");
              }
            }),
            n.addEventListener("click", function () {
              e("next");
            }),
            s.addEventListener("click", function () {
              e("prev");
            });
            if (closeButton) {
              closeButton.addEventListener(
                "click",
                function (event) {
                  event.preventDefault();
                  event.stopImmediatePropagation();
                  closeZoomModal();
                },
                true
              );
            }
        }
        const i = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              const e = t.target;
              if (t.isIntersecting) {
                const t = e.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  });
              } else e.pause();
            });
          },
          { threshold: 0.2 }
        );
        document.querySelectorAll(".product-gallery video").forEach((t) => {
          i.observe(t);
        });
      })();
  })();
  const initMobileDetailsAccordion = (scope = document) => {

    scope.querySelectorAll(".details-tab").forEach((tab) => {
      if (tab.classList.contains("details-tab--accordion")) return;

      const header = tab.querySelector(".details-tab__header");
      const content = tab.querySelector(".details-tab__content");
      if (!header || !content) return;

      const triggers = header.querySelectorAll("[data-tab-target]");
      if (!triggers.length) return;

      const accordion = document.createElement("div");
      accordion.className = "details-tab__accordion";

      triggers.forEach((trigger, index) => {
        const targetSelector = trigger.dataset.tabTarget;
        if (!targetSelector) return;

        const panel = tab.querySelector(targetSelector);
        if (!panel) return;

        const item = document.createElement("div");
        item.className = "details-tab__accordion-item";
        if (trigger.hasAttribute("hidden") || panel.hasAttribute("hidden")) {
          item.style.display = "none";
        }

        const button = document.createElement("button");
        button.type = "button";
        button.className = "details-tab__accordion-trigger";
        button.textContent = trigger.textContent.trim();

        const isActive = false;

        button.setAttribute("aria-expanded", isActive ? "true" : "false");

        panel.classList.remove("active");
        panel.classList.add("details-tab__accordion-panel");
        panel.hidden = !isActive;
        if (isActive) {
          panel.classList.add("active");
        }

        if (isActive) {
          item.classList.add("active");
        }

        button.addEventListener("click", () => {
          if (panel.hidden) {
            item.classList.add("active");
            button.setAttribute("aria-expanded", "true");
            panel.classList.add("active");
            panel.hidden = false;
          } else {
            item.classList.remove("active");
            button.setAttribute("aria-expanded", "false");
            panel.classList.remove("active");
            panel.hidden = true;
          }
        });

        item.appendChild(button);
        item.appendChild(panel);
        accordion.appendChild(item);
      });

      header.remove();
      content.remove();
      tab.appendChild(accordion);
      tab.classList.add("details-tab--accordion");
    });
  };

  initMobileDetailsAccordion();
  document.addEventListener("shopify:section:load", (event) => {
    initMobileDetailsAccordion(event.target);
  });

  const t = document.querySelectorAll("[data-tab-target]"),
    e = document.querySelectorAll("[data-tab-content]");
  t.forEach((i) => {
    i.addEventListener("click", () => {
      if (i.closest(".details-tab--accordion")) return;
      const r = document.querySelector(i.dataset.tabTarget);
      e.forEach((t) => {
        t.classList.remove("active");
      }),
        t.forEach((t) => {
          t.classList.remove("active");
        }),
        i.classList.add("active"),
        r.classList.add("active");
    });
  });
})();